import React, { useState } from "react";
import "../../css/pages/headerMain.scss";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { NavLink, useLocation } from "react-router-dom";

import Login from "../Login";
import { NAV_LINKS } from "../../constants/global";
import MobileDrawer from "./drawer";

const HeaderMain: React.FC = () => {
  const [displayLogin, setDisplayLogin] = useState(false);
  const [displayMobileNav, setDisplayMobileNav] = useState(false);

  // get the url of the current page form React Router
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path: string) => {
    return currentPath === path ? "active" : "";
  };

  const persianDate = new Intl.DateTimeFormat("fa-IR", {
    dateStyle: "full",
  }).format(new Date());

  const handleLogin = (state: boolean) => setDisplayLogin(state);

  return (
    <header className="headerContainer">
      <div className="headerWrapper">
        <div className="topBarWrapper">
          <div className="topBarRight">
            <div className="dateSection">{persianDate}</div>
            <div className="dateIcon">
              <AccessTimeIcon fontSize="small" />
            </div>
          </div>
          <div className="topBarLeft">
            <div className="socialSection"></div>
          </div>
        </div>
        <div className="navigatinPanel">
          <NavLink to="/">
            <img src="/assets/logo1.jpg" alt="logo" className="logoMain" />
          </NavLink>
          <nav>
            <ul className="primaryNav">
              <div
                id="mobile-exit"
                className="closeButton"
                onClick={() => setDisplayMobileNav(false)}
              >
                <CloseIcon style={{ color: "white", fontSize: "50px" }} />
              </div>
              {NAV_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <NavLink
                    key={to}
                    to={to}
                    onClick={() => setDisplayMobileNav(false)}
                    className={({ isActive }) =>
                      isActive ? "headerItemsActive" : ""
                    }
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
              <li
                onClick={() => setDisplayLogin((prev) => !prev)}
                onMouseEnter={(e) => e.stopPropagation()}
                onMouseLeave={(e) => e.stopPropagation()}
              >
                <span>پنل ادمین</span>
                <Login
                  displayLoginState={displayLogin}
                  closeLoginState={handleLogin}
                />
              </li>
            </ul>
          </nav>
          <MobileDrawer
            open={displayMobileNav}
            toggleDrawer={(open: boolean) => {
              setDisplayMobileNav(open);
            }}
            loginState={displayLogin}
            handleLogin={handleLogin}
          />
          <div
            id="mobile-cta"
            className="hamburgerMenu"
            onClick={() => setDisplayMobileNav((prev) => !prev)}
          >
            <MenuIcon />
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderMain;
